import { RefreshCw } from 'lucide-react';

/**
 * The console's one refresh control. Chrome differs by area (`btn btn-secondary`
 * on the config pages, `cbtn` inside Communications), so the class comes from
 * the caller — what this centralises is the behaviour every screen needs: locked
 * and spinning while in flight, with the label switching so a fast reload still
 * reads as one. `useLoad` holds `refreshing` past the response for exactly that,
 * which is why the label is driven by it and not by `busy`.
 */
export function RefreshButton({
  refreshing,
  busy = false,
  onClick,
  className = 'btn btn-secondary',
  title = 'Refresh',
  label = 'Refresh',
  size = 14,
}: {
  /** Held past the response by `useLoad` — drives the label. */
  refreshing: boolean;
  /** Any other reason to lock the button, e.g. the first load still in flight. */
  busy?: boolean;
  onClick: () => void;
  className?: string;
  title?: string;
  /** `null` renders the icon alone, for toolbars with no room for a word. */
  label?: string | null;
  size?: number;
}) {
  const spinning = refreshing || busy;
  return (
    <button
      type="button"
      className={className}
      title={spinning ? 'Refreshing…' : title}
      aria-label={label === null ? title : undefined}
      disabled={spinning}
      onClick={onClick}
    >
      <RefreshCw size={size} className={spinning ? 'spin-anim' : undefined} />
      {label !== null && (refreshing ? 'Refreshing…' : label)}
    </button>
  );
}
